import React, {useState } from 'react'
import { ThemeProvider } from '@mui/material'
import {theme} from '../../../config/Dashboardtheme'
import CenteredTabs from '../../Views/Tabs'
import RemovalStats from '../molecule/RemovalStats'
import OptOuts , { BrokerOptOuts } from './OptOuts' 

// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import Lottie from 'lottie-react'
import loaderJson from '@meprism/shared/src/assets/icons/loader.json'
interface StatsProp {
  Brokers : any[]
  unmatchedBrokers : any[]
  OptOuts: BrokerOptOuts[]
  isDataFetched : boolean
}

const ExecutiveUsersDashboardGrid = (props: StatsProp) => {
  const [tabValue, setTabValue] = useState('Removal Stats')
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue)
  }
 
  return (
    <ThemeProvider theme={theme}>
      <CenteredTabs
        value={tabValue}
        handleChange={handleTabChange}
        isGrantDateValid={true}
        
      />
      {
        !props.isDataFetched ?
        <div style={{height:'400px', width:'100%', display: 'flex', justifyContent: 'center', alignItems:'center'}}>
            <div style={{ width: 100, height: 100 }}><Lottie animationData={loaderJson} loop={true} /></div>
        </div>
        : (tabValue === 'Removal Stats' ?
        <RemovalStats Brokers={props.Brokers} unmatchedBrokers={props.unmatchedBrokers} />
        : <OptOuts optouts={props.OptOuts} />
      )}
    </ThemeProvider>
  )
}

export default ExecutiveUsersDashboardGrid